export const changeOwnerButtonAnalyticsContextAttributes = {
	role: 'owner',
	name: 'changeOwner',
	override: 'true',
};

export const getChangeOwnerButtonAnalyticsContext = (
	analyticsSource: string,
	override: 'true' | 'false',
) => ({
	source: analyticsSource,
	attributes: { role: 'owner', name: 'changeOwner', override },
});
